import React, { useState, useEffect } from 'react';

const PaginationControls = ({ 
  initialSize = 25,
  pageSizeOptions = [25, 50, 100],
  onSizeChange,
  className = "",
  style = {}
}) => {
  const [size, setSize] = useState(initialSize);

  // Update internal state when initialSize changes
  useEffect(() => {
    setSize(initialSize);
  }, [initialSize]);

  const handleSizeChange = (e) => {
    const newSize = Number(e.target.value);
    setSize(newSize);
    
    // Call parent callback if provided
    if (onSizeChange) {
      onSizeChange(newSize);
    }
  };

  return (
    <div className={className} style={style}>
      <select 
        className="form-select form-select-sm formField2 ev-btn-small ev-radius-xsmall"  
        value={size}
        onChange={handleSizeChange}
      >
        {pageSizeOptions.map(option => (
          <option key={option} value={option}>
            {option}/page
          </option>
        ))}
      </select>
    </div>
  );
};

export default PaginationControls;